import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b5a047e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-flip" }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ImageOrShapeFlip } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import CheckboxButton from '@/components/CheckboxButton.vue'
import CheckboxButtonGroup from '@/components/CheckboxButtonGroup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementFlip',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const flipH = ref(false)
const flipV = ref(false)

watch(handleElement, () => {
  if (handleElement.value && (handleElement.value.type === 'image' || handleElement.value.type === 'shape')) {
    flipH.value = !!handleElement.value.flipH
    flipV.value = !!handleElement.value.flipV
  }
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateFlip = (flipProps: ImageOrShapeFlip) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props: flipProps })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  const _component_IconFlipVertically = _resolveComponent("IconFlipVertically")!
  const _component_IconFlipHorizontally = _resolveComponent("IconFlipHorizontally")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CheckboxButtonGroup, { class: "row" }, {
      default: _withCtx(() => [
        _createVNode(CheckboxButton, {
          style: {"flex":"1"},
          checked: flipV.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (updateFlip({ flipV: !flipV.value })))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconFlipVertically),
            _createTextVNode(" 垂直翻转")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(CheckboxButton, {
          style: {"flex":"1"},
          checked: flipH.value,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (updateFlip({ flipH: !flipH.value })))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconFlipHorizontally),
            _createTextVNode(" 水平翻转")
          ]),
          _: 1
        }, 8, ["checked"])
      ]),
      _: 1
    })
  ]))
}
}

})